import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'image',
    type: 'primary',
  },
  input: {
    label: 'inline',
    height: '48px',
  },
  amountInput: {
    variant: 'outlined',
  },
  errors: {
    position: 'bottom',
    type: 'default',
  },
  balance: {
    visible: false,
  },
};
